module.exports = __webpack_public_path__ + "static/media/previous.5549c5f5.svg";